import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import React from 'react'

dayjs.extend(localizedFormat)

export const formatDatetime = (strDatetime: string) => {
  const dt = new Date(strDatetime)
  // T.B.D. Consider how to localize the datetime string
  return (
    <>
      <p>{dayjs(dt).format('LLLL, YYYY')}</p>
      <p>{dayjs(dt).format('hh:mm')}</p>
    </>
  )
}
